import React from 'react';
import { Highlight } from 'react-instantsearch';
import PropTypes from 'prop-types';

import { HitType } from '../../../Common/HitType';
import { trackClick } from '../../../../helpers/tracking-helper';

const CustomHit = ({ hit, onClick }) => {
    const type = HitType(hit);
    const displayDate = ['insights', 'news', 'events'].includes(hit.section) ? hit.formattedPostDate : null;

    return (
        <div className="result" key={hit.objectID}>
            {hit.vendorContent && (
                <div
                    style={{
                        borderRadius: '100px',
                        backgroundColor: '#EAEDED',
                        width: '76px',
                        height: '24px',
                        textAlign: 'center',
                        marginBottom: '12px',
                    }}
                >
                    <span className="result__meta" style={{ fontSize: '12px' }}>
                        Sponsored
                    </span>
                </div>
            )}
            {displayDate ? (
                <span className="meta result__meta" style={{ color: '#053364', fontSize: '14px' }}>
                    {type} <span style={{ fontWeight: '700' }}> · </span>
                    {displayDate}
                </span>
            ) : (
                <span className="meta result__meta" style={{ color: '#053364', fontSize: '14px' }}>
                    {type}
                </span>
            )}

            <a
                href={hit.uri}
                data-elementid={hit.objectID}
                onClick={() => {
                    trackClick(hit.objectID, hit.uri, true);
                    onClick();
                }}
            >
                <h4 className="result__title">
                    <Highlight hit={hit} attribute="title" />
                </h4>
                <p className="result__description">
                    <Highlight hit={hit} attribute="summary" />
                </p>
            </a>
        </div>
    );
};

CustomHit.propTypes = {
    hit: PropTypes.object,
    onClick: PropTypes.func,
};

export default CustomHit;
